/** When number of legs decreases to this amount, no more deletions are allowed */
export const MINIMUM_NUM_LEGS_ALLOWED = 2;

/** a leg inserted with divide leg will have this activityId */
export const NEW_LEG_ACTIVITY_ID = -1;

export const NUM_MILLISECONDS_PER_SECOND = 1000;

/** use these to save named snapshots */
/**
 * Last operation snapshot is made after every operation
 * When the most recent operation is invalid, use this to revert to the last valid state
 */
export const LEGS_SNAPSHOT_LAST_OPERATION = 'LEGS_SNAPSHOT_LAST_OPERATION';

/**
 * Set active leg snapshot is made right after a leg switch occurs
 */
export const LEGS_SNAPSHOT_SET_ACTIVE_LEG = 'LEGS_SNAPSHOT_SET_ACTIVE_LEG';
